import { MARKETPLACE_INVENTORY_PUSH_PROVIDERS } from "@redotech/redo-inventory-common/provider/marketplace-inventory-push";
import * as z from "zod";

export const getImsStatus = {
  name: "getImsStatus" as const,
  input: z.object({}),
  output: z.object({
    isSourceOfTruth: z.boolean(),
    inventoryPushProviders: z.array(
      z.enum(MARKETPLACE_INVENTORY_PUSH_PROVIDERS),
    ),
  }),
};
